/* tslint:disable */
import { CheckboxModel, SelectModel } from './common.model';


/**
 * Inicialización de la clase NationalityInfo, modelo de información de nacionalidad del usuario
 * 
 * *Set NationalityInfo class, user's nationality info model*
 * 
 * @access public
 * @type {class}
 */
export class NationalityInfo {
  /**
   * Id del país de nacionalidad del usuario
   * 
   * *User's country nationality id*
   * 
   * @type {string} id
   */
  id: string;

  /**
   * Valor del país de nacionalidad del usuario
   * 
   * *User's country nationality value*
   * 
   * @type {string} value
   */
  value: string;
}

/**
 * Inicialización de la clase LaborOldModel, modelo para años de labor del usuario
 * 
 * *Set LaborOldModel class, user's laborOld*
 * 
 * @access public
 * @type {class}
 */
export class LaborOldModel {
  /**
   * Instancia de variable year como SelectModel, año de labor del usuario
   * 
   * *year variable instance as SelectModel, user's year labor*
   * 
   * @type {SelectModel} year
   */
  year: SelectModel = new SelectModel();

  /**
   * Instancia de variable month como SelectModel, mes de labor del usuario
   * 
   * *month variable instance as SelectModel, user's month labor*
   * 
   * @type {SelectModel} month
   */
  month: SelectModel = new SelectModel();

  /**
   * Suma de los meses de trabajo
   * 
   * *sum Months*
   * 
   * @type {number} sumMonths
   */
  sumMonths: number;
}

/**
 * Inicialización de la clase MaritalStatusInfo, Modelo para el estado civil del usuario
 * 
 * *Set MaritalStatusInfo class, User's marital Status Info*
 * 
 * @access public
 * @type {class}
 */
export class MaritalStatusInfo {
  /**
   * Identificación del elemento
   * 
   * *Element Id*
   * 
   * @type {number} elementId
   */
  elementId: number;

  /**
   * Valor del estado civil del estado
   * 
   * *Marital Status Info Value*
   * 
   * @type {string} value
   */
  value: string;
}

/**
 * Inicialización de la clase IsPEP, modelo para conocer si la persona esta expuesa públicamente
 * 
 * *Set IsPEP class, Public exposed person model*
 * 
 * @access public
 * @type {class}
 */
export class IsPEP {
  /**
   * Identificación de elemento PEP
   * 
   * *PEP's ElementID*
   * 
   * @type {number} elementId
   */
  elementId: number;

  /**
   * Valor de PEP
   * 
   * *PEP's value*
   * 
   * @type {string} value
   */
  value: string;

  /**
   * Verificación si es una persona públicamente expuesta
   * 
   * *Public Exposed Person Validation*
   * 
   * @type {boolean} checked
   */
  checked: boolean;
}

export class IsDec {
  elementId: number;
  value: string;
  checked: boolean;
}

/**
 * Inicialización de la clase PhoneInfoModel, modelo para los numeros de teléfono
 * 
 * *Set PhoneInfoModel class, Phone infor model*
 * 
 * @access public
 * @type {class}
 */
export class PhoneInfoModel {
  /**
   * Identificación del prefijo del teléfono
   * 
   * *User's email*
   * 
   * @type {string} prefixId
   */
  prefixId: string;

  /**
   * Prefijo del número telefónico
   * 
   * *Phone number prefix*
   * 
   * @type {string} prefix
   */
  prefix: string;

  /**
   * Sufijo del número telefónico
   * 
   * *Phone number sulfix*
   * 
   * @type {string} sulfix
   */
  sulfix: string;
}

/**
 * Inicialización de la clase ContactInfoModel, información de contacto del usuario
 * 
 * *Set ContactInfoModel class, user's information contact info*
 * 
 * @access public
 * @type {class}
 */
export class ContactInfoModel {
  /**
   * Correo electrónico del usuario
   * 
   * *User's email*
   * 
   * @type {string} email
   */
  email: string;

  /**
   * Teléfono movil del usuario
   * 
   * *User's work phone*
   * 
   * @type {PhoneInfoModel} workPhone
   */
  workPhone: PhoneInfoModel;

  /**
   * Teléfono de trabajo del usuario
   * 
   * *User's mobile phone*
   * 
   * @type {PhoneInfoModel} mobilePhone
   */
  mobilePhone: PhoneInfoModel;

  /**
   * Constructor de la clase 
   *  
   * *Class Contstructor.*
   * 
   * @var {PhoneInfoModel} workPhone   Sets variables as new PhoneInfoModel
   * @var {PhoneInfoModel} mobilePhone Sets variables as new PhoneInfoModel
   * 
   */
  constructor() {
    this.workPhone = new PhoneInfoModel();
    this.mobilePhone = new PhoneInfoModel();
  }
}

/**
 * Inicialización de la clase FiModel, información básica del usuario
 * 
 * *Set FiModel class, User's basic info*
 * 
 * @access public
 * @type {class}
 */
export class FiModel {
  /**
   * Número de documento del usuario
   * 
   * *User's number document*
   * 
   * @type {number} documentNumber
   */
  documentNumber: number;

  /**
   * Validación de aceptación de términos del usuario
   * 
   * *Checkbox terms validation document*
   * 
   * @type {CheckboxModel} checkboxTerms
   */
  checkboxTerms: CheckboxModel;

  /**
   * Nacionalidad del usuario
   * 
   * *User's nationality*
   * 
   * @type {NationalityInfo} nationality
   */
  nationality: NationalityInfo;

  /**
   * Género del usuario
   * 
   * *User's gender*
   * 
   * @type {string} gender
   */
  gender: string;

  /**
   * Estado civil del usuario
   * 
   * *User's marital status*
   * 
   * @type {MaritalStatusInfo} maritalStatus
   */
  maritalStatus: MaritalStatusInfo;

  /**
   * Primer nombre del usuario
   * 
   * *User's fisrt name*
   * 
   * @type {string} firstName
   */
  firstName: string;

  /**
   * Segundo nombre del usuario
   * 
   * *User's second name*
   * 
   * @type {string} secondName
   */
  secondName: string;

  /**
   * Primer apellido del usuario
   * 
   * *User's first surname*
   * 
   * @type {string} firstSurname
   */
  firstSurname: string;

  /**
   * Segundo apellido del usuario
   * 
   * *User's second surname*
   * 
   * @type {string} secondSurname
   */
  secondSurname: string;

  /**
   * Fecha de nacimiento del usuario
   * 
   * *User's birthdate*
   * 
   * @type {string} birthdate
   */
  birthdate: string;

  /**
   * Ingresos económicos del usuario
   * 
   * *User's receipts*
   * 
   * @type {CheckboxModel[]} receipts
   */
  receipts: CheckboxModel[];

  /**
   * Años de labor del usuario
   * 
   * *User's labor old*
   * 
   * @type {LaborOldModel} laborOld
   */
  laborOld: LaborOldModel;

  /**
   * Valores de ingresos del usuario
   * 
   * *User's receipt values*
   * 
   * @type {any[]} receiptValues
   */
  receiptValues: any[];

  /**
   * Información de contacto del usuario
   * 
   * *User's contact info*
   * 
   * @type {ContactInfoModel} contactInfo
   */
  contactInfo: ContactInfoModel;

  /**
   * Identificación vendor
   * 
   * *Vendor Id*
   * 
   * @type {string} vendorId
   */
  vendorId: string;

  /**
   * Identificación de la rama
   * 
   * *Branch Id*
   * 
   * @type {string} branchId
   */
  branchId: string;


  /**
   * Constructor de la clase  
   * *Class Contstructor.*
   *  
   * @var {number}            documentNumber Sets variable as 0
   * @var {CheckboxModel}     checkboxTerms  Sets as new CheckboxModel
   * @var {NationalityInfo}   nationality    Sets as new NationalityInfo
   * @var {MaritalStatusInfo} maritalStatus  Sets as new MaritalStatusInfo
   * @var {CheckboxModel[]}   receipts       Sets as new Array<CheckboxModel>()
   * @var {LaborOldModel}     laborOld       Sets as new LaborOldModel
   * @var {Array<>()}         receiptValues  Sets as new Array<any>()
   * @var {ContactInfoModel}  contactInfo    Sets as new ContactInfoModel
   * 
   */
  constructor() {
    this.documentNumber = 0;
    this.checkboxTerms = new CheckboxModel();
    this.nationality = new NationalityInfo();
    this.maritalStatus = new MaritalStatusInfo();
    this.receipts = new Array<CheckboxModel>();
    this.laborOld = new LaborOldModel();
    this.receiptValues = new Array<any>();
    this.contactInfo = new ContactInfoModel();
  }
}

export class FiModelSecondHeadline {
  /**
   * Número de documento del usuario
   * 
   * *User's number document*
   * 
   * @type {number} documentNumber
   */
  documentNumber: number;

  /**
   * Validación de aceptación de términos del usuario
   * 
   * *Checkbox terms validation document*
   * 
   * @type {CheckboxModel} checkboxTerms
   */
  checkboxTerms: CheckboxModel;

  /**
   * Nacionalidad del usuario
   * 
   * *User's nationality*
   * 
   * @type {NationalityInfo} nationality
   */
  nationality: NationalityInfo;

  /**
   * Género del usuario
   * 
   * *User's gender*
   * 
   * @type {string} gender
   */
  gender: string;

  /**
   * Estado civil del usuario
   * 
   * *User's marital status*
   * 
   * @type {MaritalStatusInfo} maritalStatus
   */
  maritalStatus: MaritalStatusInfo;

  /**
   * Primer nombre del usuario
   * 
   * *User's fisrt name*
   * 
   * @type {string} firstName
   */
  firstName: string;

  /**
   * Segundo nombre del usuario
   * 
   * *User's second name*
   * 
   * @type {string} secondName
   */
  secondName: string;

  /**
   * Primer apellido del usuario
   * 
   * *User's first surname*
   * 
   * @type {string} firstSurname
   */
  firstSurname: string;

  /**
   * Segundo apellido del usuario
   * 
   * *User's second surname*
   * 
   * @type {string} secondSurname
   */
  secondSurname: string;

  /**
   * Fecha de nacimiento del usuario
   * 
   * *User's birthdate*
   * 
   * @type {string} birthdate
   */
  birthdate: string;

  /**
   * Ingresos económicos del usuario
   * 
   * *User's receipts*
   * 
   * @type {CheckboxModel[]} receipts
   */
  receipts: CheckboxModel[];

  /**
   * Años de labor del usuario
   * 
   * *User's labor old*
   * 
   * @type {LaborOldModel} laborOld
   */
  laborOld: LaborOldModel;

  /**
   * Valores de ingresos del usuario
   * 
   * *User's receipt values*
   * 
   * @type {any[]} receiptValues
   */
  receiptValues: any[];

  /**
   * Información de contacto del usuario
   * 
   * *User's contact info*
   * 
   * @type {ContactInfoModel} contactInfo
   */
  contactInfo: ContactInfoModel;

  /**
   * Identificación vendor
   * 
   * *Vendor Id*
   * 
   * @type {string} vendorId
   */
  vendorId: string;

  /**
   * Identificación de la rama
   * 
   * *Branch Id*
   * 
   * @type {string} branchId
   */
  branchId: string;


  /**
   * Constructor de la clase  
   * *Class Contstructor.*
   *  
   * @var {number}            documentNumber Sets variable as 0
   * @var {CheckboxModel}     checkboxTerms  Sets as new CheckboxModel
   * @var {NationalityInfo}   nationality    Sets as new NationalityInfo
   * @var {MaritalStatusInfo} maritalStatus  Sets as new MaritalStatusInfo
   * @var {CheckboxModel[]}   receipts       Sets as new Array<CheckboxModel>()
   * @var {LaborOldModel}     laborOld       Sets as new LaborOldModel
   * @var {Array<>()}         receiptValues  Sets as new Array<any>()
   * @var {ContactInfoModel}  contactInfo    Sets as new ContactInfoModel
   * 
   */
  constructor() {
    this.documentNumber = 0;
    this.checkboxTerms = new CheckboxModel();
    this.nationality = new NationalityInfo();
    this.maritalStatus = new MaritalStatusInfo();
    this.receipts = new Array<CheckboxModel>();
    this.laborOld = new LaborOldModel();
    this.receiptValues = new Array<any>();
    this.contactInfo = new ContactInfoModel();
  }
}
